<app-drawer-layout [title]="title()" [state]="content() || contentQuery.isError() ? 'ready' : 'loading'" loadingMessage="Loading guide…">
  @if (content(); as content) {
    <div class="flex flex-col gap-4">
      <a
        class="documentation-drawer-link inline-flex items-center gap-1 self-end rounded-sm text-body-sm font-semibold text-text-link no-underline outline-none hover:underline hover:underline-offset-4 focus-visible:shadow-focus"
        [href]="canonicalUrl()"
        target="_blank"
        rel="noopener"
      >
        <span>View on budgets.money</span>
        <app-ui-icon class="size-3.5" name="chevron-right" />
      </a>
      <documentation [content]="content" />
    </div>
  } @else {
    <div class="flex flex-col items-start gap-6">
      <p class="m-0 text-body-base text-text-muted">We couldn't load this guide right now.</p>
      <a appUiButton appearance="outline" tone="neutral" [href]="canonicalUrl()" target="_blank" rel="noopener">
        View on budgets.money
      </a>
    </div>
  }
</app-drawer-layout>
